<template lang="pug">
div.popupPrestamosVida
  v-dialog(v-model="openPopup" scrollable persistent width="370")
    v-card(id="popup")
      v-card-text
        .close
          img(:src="iconClose" alt="Cerrar pop-up NPS" style="float:right" width="12px" @click="closeAlertPopup")
        .step.initial(v-if="step === 1")
          img(
            :src="icon.initial"
            alt="Personaje animado"
            )
          h2.omnesMedium Solicita un préstamo fácil y rápido
          p.omnesRegular.text-primary(style="text-align: center;")
            | Tienes un préstamo preaprobado de&nbsp;
            span.omnesSemibold.max-amount hasta {{ currency }} {{ formatAmount(amountMax) }}&nbsp;
            | listo para ti.
          .button-container
            v-btn.omnesSemibold(@click.prevent="iniciarFlujoPrestamosVida") Lo quiero
        .step.request(v-if="step === 2")
          h2.omnesMedium Ingresa tus datos
          v-flex(xs12 sm12 md12 lg12)
            p.omnesRegular Completa la información de contacto solicitada.
            v-text-field.field(label="Correo" required v-model="correo"  @input="validateCorreo" :error-messages="errors.correo" maxlength="100")
            v-text-field.field(label="Teléfono" required v-model="telefono" type="tel" maxlength="9")
            p.omnesRegular Ingresa el monto que necesitas en {{ currency }}:
            v-text-field.field.monto(v-model="amount" label="Monto" ref="amount" type="tel" v-on:keypress="verifyChars($event)" @keyup.delete="clearAmountField" @keyup.enter="validarMonto" @blur="validarMonto")
            p.omnesRegular.info-small El monto máximo que puedes solicitar es {{ currency }} {{ formatAmount(amountMax) }}
            v-layout.pd-lr
              v-flex(xs12 sm12 md12 lg12)
                v-select(:items='entidadesBancarias' label="Entidad bancaria" required v-model='dataNroCuenta.entidad' @change="changeEntidadBancaria($event)")
                v-select(:items='tiposCuentas' label="Tipo de cuenta" required v-model='dataNroCuenta.tipoCuenta' @change="changeTipoCuenta($event)" :disabled="!dataNroCuenta.entidad")
                v-text-field.field(label='Número de cuenta bancaria' v-model='dataNroCuenta.nroCuenta' type='text' :mask='maskTipoCuenta' :error-messages="errors.numeroCuenta" @input="validateAccountNumber" :disabled="!dataNroCuenta.entidad || !dataNroCuenta.tipoCuenta")
                p.omnesRegular.info-small La moneda de tu cuenta bancaria debe ser la misma que el monto solicitado.
          v-flex.checkbox-container
            v-layout.row.align-start.checkbox
              v-checkbox(v-model="politicas")
              span
                | Al continuar acepto las&nbsp;
                a(href="https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro-1810.pdf" target="_blank") condiciones de uso y políticas de privacidad
                | .
            v-layout.row.align-start.checkbox
              v-checkbox(v-model="condiciones")
              span
                | Acepto las condiciones especificadas&nbsp;
                a(href="https://www.interseguro.pe/wp-content/uploads/2025/01/condiciones-prestamos-vida.pdf" target="_blank") aquí
                | .
          .button-container(style="margin-top: 1rem;")
            v-btn.omnesSemibold(:class="{'disabled': !isFormCompleted || loader}" @click="enviarSolicitud")
              template(v-if="loader")
                v-progress-circular(indeterminate color="white" size="20")
              template(v-else)
                | Continuar
        .step.confirm(v-if="step === 3")
          img(
            :src="icon.confirm"
            alt="Imagen de confirmación"
            )
          h2.omnesMedium ¡Solicitud enviada con éxito!
          p.omnesRegular.text-primary(style="text-align: center;")
            | La solicitud N°&nbsp;
            span.omnesSemibold.max-amount {{numeroSolicitud}}&nbsp;
            | ha sido ingresada, la respuesta será enviada a tu correo electrónico en los siguientes días.
          .button-container
            v-btn.omnesSemibold(@click="closeAlertPopup") Ir al inicio
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import transacts from '@/interfaces/transacts'

export default {
  props: [
    'openPopup',
  ],
  computed: {
    ...mapGetters('user', ['basicInfo', 'extraInfo']),
    isFormCompleted() {
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.correo || '');
      const isValidPhone = (this.telefono || '').length >= 9;
      const currentAmount = this.amount ? parseFloat(this.amount.replace(/,/g, '')) : 0;
      const maxAmount = parseFloat(this.amountMax.toString().replace(/,/g, ''));
      const isValidAmount = currentAmount > 0 && currentAmount <= maxAmount;
      const isValidBankAccount = this.validateAccountNumber();

      return isValidEmail &&
        isValidPhone &&
        isValidAmount &&
        isValidBankAccount &&
        this.dataNroCuenta.entidad &&
        this.dataNroCuenta.tipoCuenta &&
        this.politicas &&
        this.condiciones;
    },
  },
  data() {
    return {
      loader: false,
      popupPrestamosVida: true,
      icon: {
        initial: require('@/assets/icons/icon-prestamos-modal.svg'),
        confirm: require('@/assets/icons/icon-documento-cargado.svg')
      },
      step: 1,
      currency: 'S/',
      amount: '',
      amountMin: '1',
      amountMax: '',
      correo: '',
      telefono: '',
      politicas: false,
      condiciones: false,
      poliza: '',
      banks: [],
      dataNroCuenta: {
        entidad: null,
        tipoCuenta: null,
        tipoMoneda: null,
        nroCuenta: null
      },
      entidadesBancarias: [
        'Interbank',
        'BCP',
        'BBVA',
        'Scotiabank'
      ],
      tiposCuentas: [],
      tiposMonedas: [
        'Soles',
        'Dólares'
      ],
      maskTipoCuenta: '',
      taggeo: {},
      iconClose: require('@/assets/nps/icon-close-nps-modal.svg'),
      imgStart: require('@/assets/nps/person-start.svg'),
      imgEnd: require('@/assets/nps/person-end.gif'),
      errors: {
        telefono: [],
        correo: '', // To store validation error messages
      },
      numeroSolicitud: '',
      defaultTypeAccount: '',
      accountValidations: {
        'Scotiabank': {
          'C. Ahorro': 10,
          'C. Corriente': 10
        },
        'BCP': {
          'C. Ahorro': 14,
          'C. Corriente': 14,
          'C. Maestra': 14
        },
        'BBVA': {
          'C. Ahorro': 18,
          'C. Corriente': 18
        },
        'Interbank': {
          'C. Ahorro': 13,
          'C. Corriente': 13
        }
      },
      cuentasBancarias: [
        {
          'entidad': 'Interbank',
          'code': 'IBK',
          'tipo_cuentas': [
            {
              'tipo': 'C. Ahorro',
              'format': '###-#########-#'
            },
            {
              'tipo': 'C. Corriente',
              'format': '###-#########-#'
            }
          ]
        },
        {
          'entidad': 'BCP',
          'code': 'BCP',
          'tipo_cuentas': [
            {
              'tipo': 'C. Ahorro',
              'format': '###-########-#-##'
            },
            {
              'tipo': 'C. Maestra',
              'format': '###-########-#-##'
            },
            {
              'tipo': 'C. Corriente',
              'format': '###-########-#-##'
            }
          ]
        },
        {
          'entidad': 'BBVA',
          'code': 'BBVA',
          'tipo_cuentas': [
            {
              'tipo': 'C. Ahorro',
              'format': '####-####-##########'
            }
          ]
        },
        {
          'entidad': 'Scotiabank',
          'code': 'SCOTIABANK',
          'tipo_cuentas': [
            {
              'tipo': 'C. Ahorro',
              'format': '###-#######'
            }
          ]
        }
      ]
    }
  },
  watch: {
    extraInfo(val) {
      this.amountMax = val.montoDisponible;
      this.poliza = val.numeroPoliza;
      this.currency = val.simboloMoneda;
      this.defaultTypeAccount = val.moneda;
    },
  },
  methods: {
    ...mapActions('event', ['eventLog']),
    getDate() {
      return moment().format('YYYY-MM-DD')
    },
    closeAlertPopup(item) {
      this.$emit('closeAlertPopup', item)
      setTimeout(() => {
        self.step = 1
      }, 100)
    },
    formatAmount(num) {
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    iniciarFlujoPrestamosVida() {
      this.step = 2
      this.eventLog({
        'tipoDocumento': this.basicInfo.tipoDocumento,
        'numeroDocumento': this.basicInfo.numeroDocumento,
        'categoria': 'Préstamos',
        'nombre': 'Intención de préstamo Vida'
      })
    },
    emailErrors() {
      const errors = []
      !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.correo) && errors.push('El correo debe ser válido.')
      if (this.correo) return errors
      !this.correo && errors.push('Este campo es obligatorio.')
      return errors
    },
    verifyChars(evt) {
      let charCode = (evt.which) ? evt.which : evt.keyCode
      if (!(/^[0-9]*\.?[0-9]*$/).test(evt.key) && charCode !== 8) {
        evt.preventDefault()
      }
      if ((this.amount !== null) && (typeof this.amount === 'string')) {
        if (this.amount.indexOf('.') > -1 && this.amount.substring(this.amount.indexOf('.')).length > 2) {
          evt.preventDefault()
        }
      }
    },
    clearAmountField() {
      this.amount = null
    },
    validarMonto() {
      if (this.amount != null) {
        this.amount = parseFloat((this.amount.toString()).split(',').join(''))
        this.amountMax = parseFloat((this.amountMax.toString()).split(',').join(''))
        // CHECK IF AMOUNT ENTER FOR USER IS GREATER OR LESS THAN
        if (this.amount > this.amountMax) {
          this.amountMax = this.amountMax.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') // FORMAT NUMBERS TO STRING
          this.$swal({
            title: 'Atención',
            text: `El monto solicitado no puede exceder el monto máximo de ${this.currency} ${this.amountMax}`,
            type: 'error',
            confirmButtonText: 'Entendido'
          })
          this.amount = ''
          return false
        } else if (this.amount < this.amountMin) {
          this.amountMax = this.amountMax.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') // FORMAT NUMBERS TO STRING
          this.$swal({
            title: 'Atención',
            text: `El monto solicitado no puede ser menor al monto mínimo de ${this.currency} 1`,
            type: 'error',
            confirmButtonText: 'Entendido'
          })
          this.amount = ''
          return false
        } else if (!this.amount) {
          this.amountMax = this.amountMax.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') // FORMAT NUMBERS TO STRING
          this.amount = ''
          return false
        }
        // FORMAT NUMBERS TO STRING
        this.amountMax = this.amountMax.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        this.amount = this.amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      }
    },
    setEntidadesBancarias() {
      this.entidadesBancarias = transacts.cuentasBancarias.map((cb) => cb.entidad)
      this.dataNroCuenta.entidad = null
      this.dataNroCuenta.tipoCuenta = null
      this.dataNroCuenta.nroCuenta = null
    },
    changeTipoCuenta(value) {
      let self = this;
      self.maskTipoCuenta = this.cuentasBancarias
        .filter((cb) => cb.entidad === self.dataNroCuenta.entidad)[0]
        .tipo_cuentas.filter((tc) => tc.tipo === value)[0].format;
      this.dataNroCuenta.nroCuenta = null;
      this.errors.numeroCuenta = '';
    },
    validateCorreo() {
      const emailRegex =
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(this.correo)) {
        this.errors.correo = 'El correo ingresado no es válido.';
      } else {
        this.errors.correo = '';
      }
    },
    validateAccountNumber() {
      if (!this.dataNroCuenta.entidad || !this.dataNroCuenta.tipoCuenta) {
        this.errors.numeroCuenta = 'Seleccione banco y tipo de cuenta primero';
        return false;
      }

      const currentLength = this.dataNroCuenta.nroCuenta ?
        this.dataNroCuenta.nroCuenta.replace(/\D/g, '').length :
        0;

      const expectedLength = this.accountValidations[this.dataNroCuenta.entidad][this.dataNroCuenta.tipoCuenta];

      if (currentLength !== expectedLength) {
        this.errors.numeroCuenta = `El número de cuenta debe tener ${expectedLength} dígitos`;
        return false;
      }

      this.errors.numeroCuenta = '';
      return true;
    },
    changeEntidadBancaria(value) {
      this.tiposCuentas = transacts.cuentasBancarias
        .filter((cb) => cb.entidad === value)[0]
        .tipo_cuentas.map((tc) => tc.tipo);
      this.dataNroCuenta.tipoCuenta = null;
      this.dataNroCuenta.nroCuenta = null;
      this.errors.numeroCuenta = '';
    },
    cuenta18(cta18) {
      if (typeof cta18 !== 'string' || cta18.length < 18) {
        throw new Error('El parámetro debe ser una cadena de al menos 18 caracteres.');
      }

      // Procesar la primera parte (primer dígito de control)
      let cad1 = '';
      cad1 += (parseInt(cta18[4]) * 1).toString();
      cad1 += (parseInt(cta18[5]) * 2).toString();
      cad1 += (parseInt(cta18[6]) * 1).toString();
      cad1 += (parseInt(cta18[7]) * 2).toString();

      let valor = 3; // ---> El 0011 es constante
      for (let i = 0; i < cad1.length; i++) {
        valor += parseInt(cad1[i]);
      }
      let dig1 = ((Math.floor(valor / 10) + 1) * 10 - valor).toString().slice(-1);

      // Procesar la segunda parte (segundo dígito de control)
      let cad2 = '';
      for (let i = 8; i <= 16; i += 2) {
        cad2 += (parseInt(cta18[i]) * 1).toString();
        cad2 += (parseInt(cta18[i + 1]) * 2).toString();
      }

      valor = 0;
      for (let i = 0; i < cad2.length; i++) {
        valor += parseInt(cad2[i]);
      }
      let dig2 = ((Math.floor(valor / 10) + 1) * 10 - valor).toString().slice(-1);

      // Concatenar el resultado
      const dc = dig1 + dig2;
      const cuenta18 = `${cta18.substring(0, 8)}-${dc}-${cta18.substring(8)}`;

      return cuenta18;
    },
    async enviarSolicitud() {
      this.loader = true

      // Definir URL para la solicitud
      const url = `${process.env.REQUIREMENT_API_URL}/public-zone/request-management`;

      const data = {
        tipo: "prestamo_vida",
        contratante: {
          poliza: this.poliza,
          nombres: this.basicInfo.nombres,
          apellido_paterno: this.basicInfo.apellidoPaterno,
          apellido_materno: this.basicInfo.apellidoMaterno !== '' ? this.basicInfo.apellidoMaterno : '-',
          numero_documento: this.basicInfo.numeroDocumento,
          tipo_documento: this.basicInfo.tipoDocumento,
          correo: this.correo,
          telefono: this.telefono,
        },
        devolucion: {
          monto: this.amount,
          moneda: this.currency,
        },
        medio_devolucion: {
          numero_cuenta: this.dataNroCuenta.entidad !== 'BBVA' ? this.dataNroCuenta.nroCuenta : this.cuenta18(this.dataNroCuenta.nroCuenta),
          titular_cuenta: this.basicInfo.nombres + ' ' + this.basicInfo.apellidoPaterno + ' ' + this.basicInfo.apellidoMaterno,
          numero_documento: this.basicInfo.numeroDocumento,
          banco: this.dataNroCuenta.entidad,
          tipo_cuenta: this.defaultTypeAccount,
          medio: "Transferencia bancaria"
        },
      };

      const formData = new FormData();
      formData.append("request", JSON.stringify(data));

      try {
        const response = await fetch(url, {
          method: "POST",
          body: formData,
        });

        if (response.ok) {
          const responseData = await response.json();
          this.eventLog({
            'tipoDocumento': this.basicInfo.tipoDocumento,
            'numeroDocumento': this.basicInfo.numeroDocumento,
            'categoria': 'Préstamos',
            'nombre': 'Solicitud de préstamo Vida',
            'datos': {
              'request': data,
              'statusCode': response.status,
              'response': responseData
            }
          })
          this.numeroSolicitud = responseData.nrosolicitud;
          this.step = 3
        } else {
          console.error("Error al enviar los datos:", response);
          this.eventLog({
            'tipoDocumento': this.basicInfo.tipoDocumento,
            'numeroDocumento': this.basicInfo.numeroDocumento,
            'categoria': 'Préstamos',
            'nombre': 'Solicitud de préstamo Vida',
            'datos': {
              'request': data,
              'statusCode': response.status,
              'response': response
            }
          })
          this.$swal({
            title: '¡Oops, algo salió mal!',
            html: 'Inténtalo más tarde.',
            imageUrl: require('@/assets/characters/oops.svg'),
            confirmButtonText: 'Ok'
          })
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
        this.eventLog({
          'tipoDocumento': this.basicInfo.tipoDocumento,
          'numeroDocumento': this.basicInfo.numeroDocumento,
          'categoria': 'Préstamos',
          'nombre': 'Solicitud de préstamo Vida',
          'datos': {
            'request': data,
            'error': error
          }
        })
        this.$swal({
          title: '¡Oops, algo salió mal!',
          html: 'Inténtalo más tarde.',
          imageUrl: require('@/assets/characters/oops.svg'),
          confirmButtonText: 'Ok'
        })
      } finally {
        this.loader = false; // Stop spinner
      }
    },
  },
  mounted() {
    const self = this
    this.banks = transacts.bancos
    this.dataNroCuenta.tipoMoneda = this.currency === "S/" ? "Soles" : "Dólares"
    this.correo = this.basicInfo.correo
    this.telefono = this.basicInfo.celular
  },
  components: {}
}
</script>

<style>
.popupPrestamosVida .v-dialog:not(.v-dialog--fullscreen) {
  max-height: 90%;
}

#popup h2 {
  color: #0855C4;
  text-align: center;
  font-size: 20px;
  line-height: 1.8rem;
}

#popup .v-card__text {
  padding: 34px 18px;
}

#popup .close {
  cursor: pointer;
  margin: 5px;
  padding: 10px;
  position: absolute;
  right: 0;
  top: 0;
}

#popup p,
#popup span {
  color: #535D66;
}

#popup .text-primary,
#popup .text-primary span {
  font-size: 18px;
  line-height: 20px;
}

#popup .step {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#popup .step img {
  width: 120px;
}

#popup .step.initial,
#popup .step.confirm {
  align-items: center;
  gap: 1rem;
}

#popup .step.initial h2 {
  width: 70%;
}

#popup .step.initial p,
#popup .step.confirm p {
  margin: 0;
}

#popup .step.initial p .max-amount {
  text-wrap: nowrap;
}

#popup .step.request p {
  margin: 5px 0;
}

#popup .step.request .info-small {
  text-align: center;
  font-size: 13px;
  line-height: 13px;
  margin: 0;
}

#popup .step.request .checkbox-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
}

#popup .step.request .checkbox .v-input--selection-controls {
  margin: 0;
  padding: 0;
}

#popup .step.request .checkbox span {
  display: inline-block;
  width: 100%;
  font-size: 14px;
  line-height: 18px;
  padding-top: 2px;
}

#popup .step.step.request .checkbox span,
#popup .step.step.request .checkbox a {
  color: #535D66;
}

#popup .step.request .checkbox .v-messages {
  display: none;
}

#popup .step.request .checkbox .accent--text {
  color: #0855C4 !important;
  caret-color: #0855C4 !important;
}

#popup .button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
}

#popup .button-container button {
  background: var(--fuchsia-color) !important;
  box-shadow: none !important;
  border-radius: 4px;
  color: white;
  font-size: 18px;
  width: 145px;
  height: 47px;
  margin: 0;
  text-transform: none;
}

#popup .button-container button.disabled {
  background: #EAEAEA !important;
  pointer-events: none;
}

#popup .field .v-input__slot,
#popup .v-select__slot {
  border: 1.2px solid #ccc;
  border-radius: 3px;
}

#popup .field .v-input__slot {
  margin-bottom: 4px;
  display: flex;
  flex: 1 1 auto;
  position: relative;
}

#popup .v-input__slot::before,
#popup .v-input__slot::after {
  border: none !important;
}

#popup .v-text-field__slot {
  padding: 5px;
}

#popup .v-text-field__slot .v-label {
  height: 20px;
  line-height: 20px;
  top: 17px;
  left: 15px !important;
}

#popup .v-text-field__slot .v-label--active {
  top: 28px;
}

#popup .v-text-field__slot input {
  margin-top: 15px;
  margin-left: 10px;
  max-height: 32px;
}

#popup .v-select__slot {
  padding: 5px;
}

#popup .v-select__slot .v-label {
  top: 18px;
  left: 10px !important;
  height: 20px;
  line-height: 20px;
}

#popup .v-select__slot .v-label--active {
  top: 27px;
  left: 15px !important;
}

#popup .v-select__slot .v-select__selections {
  margin-top: 15px;
  margin-left: 10px;
}

#popup .v-select__slot .v-input__append-inner {
  margin-top: 0.7rem;
}

#popup .v-text-field__details {
  text-align: center;
}

#popup .field.monto .v-text-field__details {
  display: none;
}

@media screen and (min-width: 600px) {
  .popupPrestamosVida .v-dialog.v-dialog--active.v-dialog--persistent.v-dialog--scrollable {
    width: 420px !important;
  }
}

@media screen and (min-width: 1024px) {
  #popup .v-card__text {
    padding: 25px;
  }

  #popup .close {
    padding: 6px;
  }

  #popup .text-primary,
  #popup .text-primary span {
    font-size: 16px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/modals/prestamos-vida/PopupPrestamosVida.vue